export const FIELD_CONTACT = 'contact_id';
export const FIELD_DEAL = 'deal_id';
export const FIELD_SYSTEM = 'subtype';
export const FIELD_NAME = 'friendly_name';
